  import { put, call } from "redux-saga/effects";
  import {ActionConstants, ApiConstants} from "../constants";
  import axios from "axios";

  export default function* validatePromocodeSaga(data) {
    try {
      const result = yield call(validatePromocodeApi, data.payload);

      if (result == null || result.status !== 1) {
        yield put({
          type: ActionConstants.VALIDATE_PROMOCODE_FAILURE,
          payload: {
            result: result,
          },
        });
      } else {
        yield put({
          type: ActionConstants.VALIDATE_PROMOCODE_SUCCESS,
          payload: {
            result: result.data,
          },
        });
      }
    } catch (e) {
      yield put({
        type: ActionConstants.VALIDATE_PROMOCODE_FAILURE,
        payload: {
          result: e,
        },
      });
    }
  }

  const validatePromocodeApi = params => {
    const url = ApiConstants.URI_FE + ApiConstants.API_VALIDATE_PROMOCODE;
    return axios.post(url, params, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then(response => response.data);
  };
